export default "__VITE_ASSET__Dd_YJXi2__"